module.exports = __webpack_public_path__ + "img/map_jy.f898bdc0.png";